import { Component, ViewEncapsulation } from '@angular/core';
import { Observable } from 'rxjs';
import { FiDialogsContentBase } from '@fi-shared/fi-dialogs/fi-dialogs-content-base';

interface IFiSpinnerDialogData {
    headerText: string;
    messageText: string;
    isLoadingProgressHidden?: boolean;
    loadingProgress$?: Observable<number>;
}

@Component({
    selector: 'fi-dialogs-spinner',
    template: `
        @if (getHeaderText()) {
          <p class="mat-dialog-title" [innerHTML]="getHeaderText()"></p>
        }
        <div class="spinner-container">
          <mat-spinner></mat-spinner>
          @if (isLoadingProgressShown()) {
            <p class="spinner-progress bold">{{ getLoadingProgress() | async }} %</p>
          }
        </div>
        @if (getMessageText()) {
          <p class="mat-dialog-message" [innerHTML]="getMessageText()"></p>
        }
        `,
    styleUrls: ['./spinner.component.scss'],
    encapsulation: ViewEncapsulation.None,
    host: { class: 'fi-dialogs-spinner' },
    standalone: false,
})
export class FiDialogsSpinnerComponent<TData, TRes> extends FiDialogsContentBase<IFiSpinnerDialogData, TRes> {
    public isLoadingProgressShown(): boolean {
        return !this.data.isLoadingProgressHidden;
    }

    public getLoadingProgress(): Observable<number> {
        return this.data.loadingProgress$;
    }

    getHeaderText() {
        return this.data.headerText;
    }

    getMessageText() {
        return this.data.messageText;
    }
}
